!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("@tinacms/react-modals"), require("@tinacms/media"), require("@tinacms/react-forms"), require("@tinacms/react-screens"), require("@tinacms/fields"), require("@tinacms/form-builder"), require("react-tinacms-editor"), require("@tinacms/react-core"), require("react"), require("@tinacms/icons"), require("@tinacms/styles"), require("@tinacms/react-sidebar"), require("@tinacms/react-alerts"), require("@tinacms/core"), require("react-datetime"), require("styled-components"), require("moment"), require("@tinacms/alerts"), require("@tinacms/forms")) : "function" == typeof define && define.amd ? define(["exports", "@tinacms/react-modals", "@tinacms/media", "@tinacms/react-forms", "@tinacms/react-screens", "@tinacms/fields", "@tinacms/form-builder", "react-tinacms-editor", "@tinacms/react-core", "react", "@tinacms/icons", "@tinacms/styles", "@tinacms/react-sidebar", "@tinacms/react-alerts", "@tinacms/core", "react-datetime", "styled-components", "moment", "@tinacms/alerts", "@tinacms/forms"], e) : e((n = n || self).tinacms = {}, n.reactModals, n.media, n.reactForms, n.reactScreens, n.fields, n.formBuilder, n.reactTinacmsEditor, n.reactCore, n.React, n.icons, n.styles, n.reactSidebar, n.reactAlerts, n.core, n.ReactDatetime, n.styled, n.moment, n.alerts, n.forms);
}(this, function (e, i, a, t, n, d, r, o, l, c, s, u, p, m, h, f, g, b, y, v) {
  "use strict";

  var x = "default" in c ? c.default : c;
  f = f && f.hasOwnProperty("default") ? f.default : f, g = g && g.hasOwnProperty("default") ? g.default : g, b = b && b.hasOwnProperty("default") ? b.default : b;

  var k = function k(n, e, r) {
    this.form = n, this.__type = "screen", this.name = n.label, this.Icon = e || s.SettingsIcon, this.layout = r || "popup", this.Component = function () {
      return c.createElement(t.FormView, {
        activeForm: n
      });
    };
  };

  var _P = function P(n, e) {
    return (_P = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (n, e) {
      n.__proto__ = e;
    } || function (n, e) {
      for (var r in e) {
        e.hasOwnProperty(r) && (n[r] = e[r]);
      }
    })(n, e);
  };

  var _w = function w() {
    return (_w = Object.assign || function (n) {
      for (var e, r = 1, t = arguments.length; r < t; r++) {
        for (var o in e = arguments[r]) {
          Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
        }
      }

      return n;
    }).apply(this, arguments);
  };

  function O(r, t) {
    var o,
        i,
        a,
        n,
        d = {
      label: 0,
      sent: function sent() {
        if (1 & a[0]) throw a[1];
        return a[1];
      },
      trys: [],
      ops: []
    };
    return n = {
      next: e(0),
      throw: e(1),
      return: e(2)
    }, "function" == typeof Symbol && (n[Symbol.iterator] = function () {
      return this;
    }), n;

    function e(e) {
      return function (n) {
        return function (e) {
          if (o) throw new TypeError("Generator is already executing.");

          for (; d;) {
            try {
              if (o = 1, i && (a = 2 & e[0] ? i.return : e[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, e[1])).done) return a;

              switch (i = 0, a && (e = [2 & e[0], a.value]), e[0]) {
                case 0:
                case 1:
                  a = e;
                  break;

                case 4:
                  return d.label++, {
                    value: e[1],
                    done: !1
                  };

                case 5:
                  d.label++, i = e[1], e = [0];
                  continue;

                case 7:
                  e = d.ops.pop(), d.trys.pop();
                  continue;

                default:
                  if (!(a = 0 < (a = d.trys).length && a[a.length - 1]) && (6 === e[0] || 2 === e[0])) {
                    d = 0;
                    continue;
                  }

                  if (3 === e[0] && (!a || e[1] > a[0] && e[1] < a[3])) {
                    d.label = e[1];
                    break;
                  }

                  if (6 === e[0] && d.label < a[1]) {
                    d.label = a[1], a = e;
                    break;
                  }

                  if (a && d.label < a[2]) {
                    d.label = a[2], d.ops.push(e);
                    break;
                  }

                  a[2] && d.ops.pop(), d.trys.pop();
                  continue;
              }

              e = t.call(r, d);
            } catch (n) {
              e = [6, n], i = 0;
            } finally {
              o = a = 0;
            }
          }

          if (5 & e[0]) throw e[1];
          return {
            value: e[0] ? e[1] : void 0,
            done: !0
          };
        }([e, n]);
      };
    }
  }

  function C(n, e) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
      value: e
    }) : n.raw = e, n;
  }

  function S(n) {
    var e = n.cms,
        r = n.children,
        t = n.hidden,
        o = n.position;
    return c.createElement(l.CMSContext.Provider, {
      value: e
    }, c.createElement(i.ModalProvider, null, c.createElement(u.GlobalStyles, null), c.createElement(m.Alerts, {
      alerts: e.alerts
    }), c.createElement(p.SidebarProvider, {
      hidden: t,
      position: o,
      sidebar: e.sidebar
    }, r)));
  }

  var F,
      M,
      j,
      z = S,
      E = g.div.withConfig({
    displayName: "ReactDateTimeContainer",
    componentId: "sc-1vo5sat"
  })(F = F || C(["\n  .rdt {\n    position: relative;\n  }\n  .rdtPicker {\n    display: none;\n    position: absolute;\n    width: 100%;\n    max-width: 350px;\n    padding: 4px;\n    margin-top: 4px;\n    z-index: 99999 !important;\n    background: var(--tina-color-grey-0);\n    border-radius: var(--tina-radius-small);\n    box-shadow: var(--tina-shadow-big);\n    border: 1px solid var(--tina-color-grey-2);\n  }\n  .rdtOpen .rdtPicker {\n    display: block;\n  }\n  .rdtStatic .rdtPicker {\n    box-shadow: none;\n    position: static;\n  }\n  .rdtPicker .rdtTimeToggle {\n    text-align: center;\n  }\n  .rdtPicker table {\n    width: 100%;\n    margin: 0;\n  }\n  .rdtPicker td,\n  .rdtPicker th {\n    text-align: center;\n    height: 28px;\n  }\n  .rdtPicker td {\n    cursor: pointer;\n  }\n  .rdtPicker td.rdtDay:hover,\n  .rdtPicker td.rdtHour:hover,\n  .rdtPicker td.rdtMinute:hover,\n  .rdtPicker td.rdtSecond:hover,\n  .rdtPicker .rdtTimeToggle:hover {\n    background: var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    border-radius: var(--tina-radius-small);\n    cursor: pointer;\n\n    &:active {\n      background: var(--tina-color-primary);\n      color: var(--tina-color-grey-0);\n      border-radius: var(--tina-radius-small);\n    }\n  }\n  .rdtPicker td.rdtOld,\n  .rdtPicker td.rdtNew {\n    color: var(--tina-color-grey-6);\n  }\n  .rdtPicker td.rdtToday {\n    position: relative;\n  }\n  .rdtPicker td.rdtToday:before {\n    content: '';\n    display: inline-block;\n    border-left: 7px solid transparent;\n    border-bottom: 7px solid var(--tina-color-primary);\n    border-radius: 20px;\n    border-top-color: rgba(0, 0, 0, 0.2);\n    position: absolute;\n    bottom: 4px;\n    right: 4px;\n  }\n  .rdtPicker td.rdtActive,\n  .rdtPicker td.rdtActive:hover {\n    background-color: var(--tina-color-primary);\n    color: var(--tina-color-grey-0);\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n  }\n  .rdtPicker td.rdtActive.rdtToday:before {\n    border-bottom-color: var(--tina-color-grey-0);\n  }\n  .rdtPicker td.rdtDisabled,\n  .rdtPicker td.rdtDisabled:hover {\n    background: none;\n    color: var(--tina-color-grey-6);\n    cursor: not-allowed;\n  }\n  .rdtPicker td span.rdtOld {\n    color: var(--tina-color-grey-6);\n  }\n  .rdtPicker td span.rdtDisabled,\n  .rdtPicker td span.rdtDisabled:hover {\n    background: none;\n    color: var(--tina-color-grey-6);\n    cursor: not-allowed;\n  }\n  .rdtPicker th {\n    border-bottom: 1px solid var(--tina-color-grey-1);\n  }\n  .rdtPicker .dow {\n    width: 14.2857%;\n    border-bottom: none;\n    cursor: default;\n  }\n  .rdtPicker th.rdtSwitch {\n    width: 100px;\n  }\n  .rdtPicker th.rdtNext,\n  .rdtPicker th.rdtPrev {\n    font-size: 21px;\n    vertical-align: top;\n  }\n  .rdtPrev span,\n  .rdtNext span {\n    display: block;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Chrome/Safari/Opera */\n    -khtml-user-select: none; /* Konqueror */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n  }\n  .rdtPicker th.rdtDisabled,\n  .rdtPicker th.rdtDisabled:hover {\n    background: none;\n    color: var(--tina-color-grey-6);\n    cursor: not-allowed;\n  }\n  .rdtPicker thead tr:first-child th {\n    cursor: pointer;\n  }\n  .rdtPicker thead tr:first-child th:hover {\n    background: var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    border-radius: var(--tina-radius-small);\n  }\n  .rdtPicker tfoot {\n    border-top: 1px solid var(--tina-color-grey-1);\n  }\n  .rdtPicker button {\n    border: none;\n    background: none;\n    cursor: pointer;\n  }\n  .rdtPicker button:hover {\n    background: var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    border-radius: var(--tina-radius-small);\n  }\n  .rdtPicker thead button {\n    width: 100%;\n    height: 100%;\n  }\n  td.rdtMonth,\n  td.rdtYear {\n    height: 50px;\n    width: 25%;\n    cursor: pointer;\n  }\n  td.rdtMonth:hover,\n  td.rdtYear:hover {\n    background: var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    border-radius: var(--tina-radius-small);\n  }\n  .rdtCounters {\n    display: inline-block;\n  }\n  .rdtCounters > div {\n    float: left;\n  }\n  .rdtCounter {\n    height: 100px;\n  }\n  .rdtCounter {\n    width: 40px;\n  }\n  .rdtCounterSeparator {\n    line-height: 100px;\n  }\n  .rdtCounter .rdtBtn {\n    height: 40%;\n    line-height: 40px;\n    cursor: pointer;\n    display: block;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Chrome/Safari/Opera */\n    -khtml-user-select: none; /* Konqueror */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n  }\n  .rdtCounter .rdtBtn:hover {\n    background: var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    border-radius: var(--tina-radius-small);\n  }\n  .rdtCounter .rdtCount {\n    height: 20%;\n    font-size: 1.2em;\n  }\n  .rdtMilli {\n    vertical-align: middle;\n    padding-left: 8px;\n    width: 48px;\n  }\n  .rdtMilli input {\n    width: 100%;\n    font-size: 1.2em;\n    margin-top: 37px;\n  }\n  .rdtTime td {\n    cursor: default;\n  }\n"], ["\n  .rdt {\n    position: relative;\n  }\n  .rdtPicker {\n    display: none;\n    position: absolute;\n    width: 100%;\n    max-width: 350px;\n    padding: 4px;\n    margin-top: 4px;\n    z-index: 99999 !important;\n    background: var(--tina-color-grey-0);\n    border-radius: var(--tina-radius-small);\n    box-shadow: var(--tina-shadow-big);\n    border: 1px solid var(--tina-color-grey-2);\n  }\n  .rdtOpen .rdtPicker {\n    display: block;\n  }\n  .rdtStatic .rdtPicker {\n    box-shadow: none;\n    position: static;\n  }\n  .rdtPicker .rdtTimeToggle {\n    text-align: center;\n  }\n  .rdtPicker table {\n    width: 100%;\n    margin: 0;\n  }\n  .rdtPicker td,\n  .rdtPicker th {\n    text-align: center;\n    height: 28px;\n  }\n  .rdtPicker td {\n    cursor: pointer;\n  }\n  .rdtPicker td.rdtDay:hover,\n  .rdtPicker td.rdtHour:hover,\n  .rdtPicker td.rdtMinute:hover,\n  .rdtPicker td.rdtSecond:hover,\n  .rdtPicker .rdtTimeToggle:hover {\n    background: var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    border-radius: var(--tina-radius-small);\n    cursor: pointer;\n\n    &:active {\n      background: var(--tina-color-primary);\n      color: var(--tina-color-grey-0);\n      border-radius: var(--tina-radius-small);\n    }\n  }\n  .rdtPicker td.rdtOld,\n  .rdtPicker td.rdtNew {\n    color: var(--tina-color-grey-6);\n  }\n  .rdtPicker td.rdtToday {\n    position: relative;\n  }\n  .rdtPicker td.rdtToday:before {\n    content: '';\n    display: inline-block;\n    border-left: 7px solid transparent;\n    border-bottom: 7px solid var(--tina-color-primary);\n    border-radius: 20px;\n    border-top-color: rgba(0, 0, 0, 0.2);\n    position: absolute;\n    bottom: 4px;\n    right: 4px;\n  }\n  .rdtPicker td.rdtActive,\n  .rdtPicker td.rdtActive:hover {\n    background-color: var(--tina-color-primary);\n    color: var(--tina-color-grey-0);\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n  }\n  .rdtPicker td.rdtActive.rdtToday:before {\n    border-bottom-color: var(--tina-color-grey-0);\n  }\n  .rdtPicker td.rdtDisabled,\n  .rdtPicker td.rdtDisabled:hover {\n    background: none;\n    color: var(--tina-color-grey-6);\n    cursor: not-allowed;\n  }\n  .rdtPicker td span.rdtOld {\n    color: var(--tina-color-grey-6);\n  }\n  .rdtPicker td span.rdtDisabled,\n  .rdtPicker td span.rdtDisabled:hover {\n    background: none;\n    color: var(--tina-color-grey-6);\n    cursor: not-allowed;\n  }\n  .rdtPicker th {\n    border-bottom: 1px solid var(--tina-color-grey-1);\n  }\n  .rdtPicker .dow {\n    width: 14.2857%;\n    border-bottom: none;\n    cursor: default;\n  }\n  .rdtPicker th.rdtSwitch {\n    width: 100px;\n  }\n  .rdtPicker th.rdtNext,\n  .rdtPicker th.rdtPrev {\n    font-size: 21px;\n    vertical-align: top;\n  }\n  .rdtPrev span,\n  .rdtNext span {\n    display: block;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Chrome/Safari/Opera */\n    -khtml-user-select: none; /* Konqueror */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n  }\n  .rdtPicker th.rdtDisabled,\n  .rdtPicker th.rdtDisabled:hover {\n    background: none;\n    color: var(--tina-color-grey-6);\n    cursor: not-allowed;\n  }\n  .rdtPicker thead tr:first-child th {\n    cursor: pointer;\n  }\n  .rdtPicker thead tr:first-child th:hover {\n    background: var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    border-radius: var(--tina-radius-small);\n  }\n  .rdtPicker tfoot {\n    border-top: 1px solid var(--tina-color-grey-1);\n  }\n  .rdtPicker button {\n    border: none;\n    background: none;\n    cursor: pointer;\n  }\n  .rdtPicker button:hover {\n    background: var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    border-radius: var(--tina-radius-small);\n  }\n  .rdtPicker thead button {\n    width: 100%;\n    height: 100%;\n  }\n  td.rdtMonth,\n  td.rdtYear {\n    height: 50px;\n    width: 25%;\n    cursor: pointer;\n  }\n  td.rdtMonth:hover,\n  td.rdtYear:hover {\n    background: var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    border-radius: var(--tina-radius-small);\n  }\n  .rdtCounters {\n    display: inline-block;\n  }\n  .rdtCounters > div {\n    float: left;\n  }\n  .rdtCounter {\n    height: 100px;\n  }\n  .rdtCounter {\n    width: 40px;\n  }\n  .rdtCounterSeparator {\n    line-height: 100px;\n  }\n  .rdtCounter .rdtBtn {\n    height: 40%;\n    line-height: 40px;\n    cursor: pointer;\n    display: block;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Chrome/Safari/Opera */\n    -khtml-user-select: none; /* Konqueror */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n  }\n  .rdtCounter .rdtBtn:hover {\n    background: var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    border-radius: var(--tina-radius-small);\n  }\n  .rdtCounter .rdtCount {\n    height: 20%;\n    font-size: 1.2em;\n  }\n  .rdtMilli {\n    vertical-align: middle;\n    padding-left: 8px;\n    width: 48px;\n  }\n  .rdtMilli input {\n    width: 100%;\n    font-size: 1.2em;\n    margin-top: 37px;\n  }\n  .rdtTime td {\n    cursor: default;\n  }\n"])),
      q = "MMM DD, YYYY",
      T = d.wrapFieldsWithMeta(function (n) {
    var e = n.input,
        r = n.field,
        t = c.useState(!1),
        o = t[0],
        i = t[1],
        a = c.useRef(null);
    return c.useEffect(function () {
      function n(n) {
        a.current && n.target && (a.current.contains(n.target) ? i(!0) : i(!1));
      }

      return document.addEventListener("mouseup", n, !1), function () {
        document.removeEventListener("mouseup", n, !1);
      };
    }, [document]), c.createElement(D, null, c.createElement(E, {
      ref: a
    }, c.createElement(f, _w({
      value: e.value,
      onFocus: e.onFocus,
      onChange: e.onChange,
      open: o,
      timeFormat: !1,
      utc: !0
    }, r))));
  }),
      D = g.div.withConfig({
    displayName: "DatetimeContainer",
    componentId: "sc-1c1s3we"
  })(M = M || C(["\n  input {\n    ", ";\n  }\n"], ["\n  input {\n    ", ";\n  }\n"]), d.InputCss),
      I = {
    name: "date",
    Component: T,
    format: function format(n, e, r) {
      var t = "string" == typeof r.dateFormat ? r.dateFormat : q;
      if ("string" != typeof n) return b(n).format(t);
      var o = b(n);
      return o.isValid() ? o.format(t) : n;
    },
    parse: function parse(n, e, r) {
      var t = "string" == typeof r.dateFormat ? r.dateFormat : q;
      if ("string" != typeof n) return n.toDate();
      var o = b(n, t);
      return o.isValid() ? o.toDate() : n;
    }
  },
      _ = "rgb(200, 200, 200)",
      A = "rgb(40, 40, 40)";

  function N(n) {
    return d.wrapFieldsWithMeta(g(n)(j = j || C(["\n    position: relative;\n\n    > [contenteditable] {\n      ", "\n      overflow: auto;\n      -webkit-overflow-scrolling: touch;\n      min-height: 200px;\n      max-height: 500px;\n      overflow-y: auto;\n      display: block;\n\n      ::selection {\n        background-color: rgba(0, 132, 255, 0.3);\n      }\n\n      div::selection {\n        background: rgba(0, 0, 0, 0);\n      }\n\n      div[contenteditable] {\n        display: inline-block;\n      }\n\n      > *:first-child {\n        margin-top: 0;\n      }\n\n      > *:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    color: ", ";\n    background-color: #fff;\n    font-size: 16px;\n    line-height: 26px;\n    white-space: pre-wrap;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: none;\n    font-weight: 400;\n    cursor: auto;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    border-radius: var(--tina-radius-small);\n\n    p {\n      font-size: 16px;\n      line-height: 26px;\n      font-weight: normal;\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      font-weight: 600;\n      text-transform: none;\n      padding: 0;\n      margin-bottom: 16px;\n    }\n\n    h1 {\n      font-size: 40px;\n      line-height: 48px;\n      margin-top: 0;\n      &:not(:first-child) {\n        margin-top: 32px;\n      }\n    }\n\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      &:not(:first-child) {\n        margin-top: 21px;\n      }\n    }\n\n    h2 {\n      font-size: 34px;\n      line-height: 38px;\n      margin-top: 0;\n    }\n\n    h3 {\n      font-size: 26px;\n      line-height: 30px;\n      margin-top: 0;\n    }\n\n    h4 {\n      font-size: 21px;\n      line-height: 28px;\n      margin-top: 0;\n    }\n\n    h5 {\n      font-size: 18px;\n      line-height: 24px;\n      margin-top: 0;\n    }\n\n    h6 {\n      font-size: 16px;\n      line-height: 20px;\n      margin-top: 0;\n    }\n\n    a {\n      color: #0084ff;\n      border: 0;\n      font-weight: normal;\n      text-decoration: underline;\n    }\n\n    small {\n      font-size: 0.707em;\n    }\n\n    ul,\n    ol {\n      margin: 0;\n      padding: 0;\n    }\n\n    ol li {\n      /* prevent 2-digits numbers from being cut-off */\n      margin-left: 5px;\n      margin-right: 5px;\n    }\n\n    ul {\n      margin-left: 1.5em;\n      margin-bottom: 16px;\n      list-style-type: disc;\n      list-style-position: outside;\n      list-style-image: none;\n    }\n\n    ol {\n      margin-left: 1.25em;\n      margin-bottom: 16px;\n      list-style-type: decimal;\n    }\n\n    li {\n      list-style: inherit;\n      ol,\n      ul {\n        margin-bottom: 0;\n      }\n    }\n\n    code {\n      font-family: 'Roboto Mono', monospace;\n      font-size: 14px;\n      background: rgba(53, 50, 50, 0.08);\n      padding: 0.1em 0.25em;\n    }\n\n    pre {\n      padding: 0;\n      margin: 0;\n    }\n\n    pre > code {\n      display: block;\n      padding: 0.15em 0.6em;\n    }\n\n    img {\n      max-width: 100%;\n      border: 0;\n      padding: 0;\n      margin-bottom: 16px;\n    }\n\n    hr {\n      display: block;\n      height: 1px;\n      width: 100%;\n      border: 0;\n      background: ", ";\n      margin: 16px 0;\n    }\n\n    blockquote {\n      margin: 0 0 16px 0;\n      border-left: 2px solid ", ";\n      padding-left: 15px;\n    }\n\n    mark {\n      color: ", ";\n      background-color: #ffe9a8;\n      padding: 0.1em 0.25em;\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      position: relative;\n      &:before {\n        font-size: 14px;\n        text-align: left;\n        font-weight: 500;\n        color: ", ";\n        position: absolute;\n        left: -35px;\n        width: 30px;\n        cursor: pointer;\n        transition: color 0.25s ease;\n      }\n      &:hover:before {\n        color: ", ";\n      }\n    }\n\n    blockquote {\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6 {\n        &:before {\n          display: none;\n        }\n      }\n    }\n  "], ["\n    position: relative;\n\n    > [contenteditable] {\n      ", "\n      overflow: auto;\n      -webkit-overflow-scrolling: touch;\n      min-height: 200px;\n      max-height: 500px;\n      overflow-y: auto;\n      display: block;\n\n      ::selection {\n        background-color: rgba(0, 132, 255, 0.3);\n      }\n\n      div::selection {\n        background: rgba(0, 0, 0, 0);\n      }\n\n      div[contenteditable] {\n        display: inline-block;\n      }\n\n      > *:first-child {\n        margin-top: 0;\n      }\n\n      > *:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    color: ", ";\n    background-color: #fff;\n    font-size: 16px;\n    line-height: 26px;\n    white-space: pre-wrap;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: none;\n    font-weight: 400;\n    cursor: auto;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    border-radius: var(--tina-radius-small);\n\n    p {\n      font-size: 16px;\n      line-height: 26px;\n      font-weight: normal;\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      font-weight: 600;\n      text-transform: none;\n      padding: 0;\n      margin-bottom: 16px;\n    }\n\n    h1 {\n      font-size: 40px;\n      line-height: 48px;\n      margin-top: 0;\n      &:not(:first-child) {\n        margin-top: 32px;\n      }\n    }\n\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      &:not(:first-child) {\n        margin-top: 21px;\n      }\n    }\n\n    h2 {\n      font-size: 34px;\n      line-height: 38px;\n      margin-top: 0;\n    }\n\n    h3 {\n      font-size: 26px;\n      line-height: 30px;\n      margin-top: 0;\n    }\n\n    h4 {\n      font-size: 21px;\n      line-height: 28px;\n      margin-top: 0;\n    }\n\n    h5 {\n      font-size: 18px;\n      line-height: 24px;\n      margin-top: 0;\n    }\n\n    h6 {\n      font-size: 16px;\n      line-height: 20px;\n      margin-top: 0;\n    }\n\n    a {\n      color: #0084ff;\n      border: 0;\n      font-weight: normal;\n      text-decoration: underline;\n    }\n\n    small {\n      font-size: 0.707em;\n    }\n\n    ul,\n    ol {\n      margin: 0;\n      padding: 0;\n    }\n\n    ol li {\n      /* prevent 2-digits numbers from being cut-off */\n      margin-left: 5px;\n      margin-right: 5px;\n    }\n\n    ul {\n      margin-left: 1.5em;\n      margin-bottom: 16px;\n      list-style-type: disc;\n      list-style-position: outside;\n      list-style-image: none;\n    }\n\n    ol {\n      margin-left: 1.25em;\n      margin-bottom: 16px;\n      list-style-type: decimal;\n    }\n\n    li {\n      list-style: inherit;\n      ol,\n      ul {\n        margin-bottom: 0;\n      }\n    }\n\n    code {\n      font-family: 'Roboto Mono', monospace;\n      font-size: 14px;\n      background: rgba(53, 50, 50, 0.08);\n      padding: 0.1em 0.25em;\n    }\n\n    pre {\n      padding: 0;\n      margin: 0;\n    }\n\n    pre > code {\n      display: block;\n      padding: 0.15em 0.6em;\n    }\n\n    img {\n      max-width: 100%;\n      border: 0;\n      padding: 0;\n      margin-bottom: 16px;\n    }\n\n    hr {\n      display: block;\n      height: 1px;\n      width: 100%;\n      border: 0;\n      background: ", ";\n      margin: 16px 0;\n    }\n\n    blockquote {\n      margin: 0 0 16px 0;\n      border-left: 2px solid ", ";\n      padding-left: 15px;\n    }\n\n    mark {\n      color: ", ";\n      background-color: #ffe9a8;\n      padding: 0.1em 0.25em;\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      position: relative;\n      &:before {\n        font-size: 14px;\n        text-align: left;\n        font-weight: 500;\n        color: ", ";\n        position: absolute;\n        left: -35px;\n        width: 30px;\n        cursor: pointer;\n        transition: color 0.25s ease;\n      }\n      &:hover:before {\n        color: ", ";\n      }\n    }\n\n    blockquote {\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6 {\n        &:before {\n          display: none;\n        }\n      }\n    }\n  "]), d.InputCss, A, _, _, A, _, A));
  }

  var R,
      G,
      B,
      W = {
    name: "html",
    Component: N(function (n) {
      return x.createElement(o.Wysiwyg, _w({}, n, {
        sticky: !1,
        format: "html"
      }));
    }),
    parse: d.TextFieldPlugin.parse
  },
      Y = {
    name: "markdown",
    Component: N(function (n) {
      return x.createElement(o.Wysiwyg, _w({}, n, {
        sticky: !1,
        format: "markdown"
      }));
    }),
    parse: d.TextFieldPlugin.parse
  },
      L = (B = h.CMS, _P(R = K, G = B), void (R.prototype = null === G ? Object.create(G) : (V.prototype = G.prototype, new V())), Object.defineProperty(K.prototype, "forms", {
    get: function get() {
      return this.plugins.findOrCreateMap("form");
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(K.prototype, "fields", {
    get: function get() {
      return this.plugins.findOrCreateMap("field");
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(K.prototype, "screens", {
    get: function get() {
      return this.plugins.findOrCreateMap("screen");
    },
    enumerable: !0,
    configurable: !0
  }), K);

  function V() {
    this.constructor = R;
  }

  function K(n) {
    void 0 === n && (n = {});

    var e = n.sidebar,
        r = n.media,
        t = function (n, e) {
      var r = {};

      for (var t in n) {
        Object.prototype.hasOwnProperty.call(n, t) && e.indexOf(t) < 0 && (r[t] = n[t]);
      }

      if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (t = Object.getOwnPropertySymbols(n); o < t.length; o++) {
          e.indexOf(t[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, t[o]) && (r[t[o]] = n[t[o]]);
        }
      }

      return r;
    }(n, ["sidebar", "media"]),
        o = B.call(this, t) || this;

    o.alerts = new y.Alerts();
    var i = (null == r ? void 0 : r.store) || new H();
    return o.media = new a.MediaManager(i), o.sidebar = new p.SidebarState(e), o.fields.add(d.TextFieldPlugin), o.fields.add(d.TextareaFieldPlugin), o.fields.add(I), o.fields.add(d.ImageFieldPlugin), o.fields.add(d.ColorFieldPlugin), o.fields.add(d.NumberFieldPlugin), o.fields.add(d.ToggleFieldPlugin), o.fields.add(d.SelectFieldPlugin), o.fields.add(Y), o.fields.add(W), o.fields.add(d.GroupFieldPlugin), o.fields.add(d.GroupListFieldPlugin), o.fields.add(d.BlocksFieldPlugin), o;
  }

  var H = (U.prototype.persist = function (e) {
    return function (i, a, d, l) {
      return new (d = d || Promise)(function (n, e) {
        function r(n) {
          try {
            o(l.next(n));
          } catch (n) {
            e(n);
          }
        }

        function t(n) {
          try {
            o(l.throw(n));
          } catch (n) {
            e(n);
          }
        }

        function o(e) {
          e.done ? n(e.value) : new d(function (n) {
            n(e.value);
          }).then(r, t);
        }

        o((l = l.apply(i, a || [])).next());
      });
    }(this, void 0, void 0, function () {
      return O(this, function (n) {
        return alert("UPLOADING FILES"), console.log(e), [2, e.map(function (n) {
          return {
            directory: n.directory,
            filename: n.file.name
          };
        })];
      });
    });
  }, U);

  function U() {
    this.accept = "*";
  }

  Object.keys(i).forEach(function (n) {
    "default" !== n && Object.defineProperty(e, n, {
      enumerable: !0,
      get: function get() {
        return i[n];
      }
    });
  }), Object.keys(a).forEach(function (n) {
    "default" !== n && Object.defineProperty(e, n, {
      enumerable: !0,
      get: function get() {
        return a[n];
      }
    });
  }), Object.keys(d).forEach(function (n) {
    "default" !== n && Object.defineProperty(e, n, {
      enumerable: !0,
      get: function get() {
        return d[n];
      }
    });
  }), Object.keys(r).forEach(function (n) {
    "default" !== n && Object.defineProperty(e, n, {
      enumerable: !0,
      get: function get() {
        return r[n];
      }
    });
  }), Object.defineProperty(e, "ActionButton", {
    enumerable: !0,
    get: function get() {
      return t.ActionButton;
    }
  }), Object.defineProperty(e, "useScreenPlugin", {
    enumerable: !0,
    get: function get() {
      return n.useScreenPlugin;
    }
  }), Object.defineProperty(e, "Wysiwyg", {
    enumerable: !0,
    get: function get() {
      return o.Wysiwyg;
    }
  }), Object.defineProperty(e, "CMSContext", {
    enumerable: !0,
    get: function get() {
      return l.CMSContext;
    }
  }), Object.defineProperty(e, "ERROR_MISSING_CMS", {
    enumerable: !0,
    get: function get() {
      return l.ERROR_MISSING_CMS;
    }
  }), Object.defineProperty(e, "useForm", {
    enumerable: !0,
    get: function get() {
      return l.useForm;
    }
  }), Object.defineProperty(e, "useLocalForm", {
    enumerable: !0,
    get: function get() {
      return l.useLocalForm;
    }
  }), Object.defineProperty(e, "usePlugin", {
    enumerable: !0,
    get: function get() {
      return l.usePlugin;
    }
  }), Object.defineProperty(e, "usePlugins", {
    enumerable: !0,
    get: function get() {
      return l.usePlugins;
    }
  }), Object.defineProperty(e, "useSubscribable", {
    enumerable: !0,
    get: function get() {
      return l.useSubscribable;
    }
  }), Object.defineProperty(e, "useWatchFormValues", {
    enumerable: !0,
    get: function get() {
      return l.useWatchFormValues;
    }
  }), Object.defineProperty(e, "withPlugin", {
    enumerable: !0,
    get: function get() {
      return l.withPlugin;
    }
  }), Object.defineProperty(e, "withPlugins", {
    enumerable: !0,
    get: function get() {
      return l.withPlugins;
    }
  }), Object.defineProperty(e, "Form", {
    enumerable: !0,
    get: function get() {
      return v.Form;
    }
  }), e.CMS = L, e.GlobalFormPlugin = k, e.Tina = z, e.TinaCMS = L, e.TinaProvider = S, e.useCMS = function () {
    return l.useCMS();
  }, e.useGlobalForm = function (n, e) {
    void 0 === e && (e = {});
    var r = l.useForm(n, e),
        t = r[0],
        o = r[1],
        i = c.useMemo(function () {
      if (o) return new k(o);
    }, [o]);
    return l.usePlugins(i), [t, o];
  }, e.withTina = function (t, o) {
    return function (n) {
      var e = c.useMemo(function () {
        return function (n) {
          return require("lodash.merge")({
            plugins: [],
            apis: {},
            sidebar: {
              position: "displace",
              hidden: !1
            }
          }, require("lodash.clonedeep")(n));
        }(o);
      }, [o]),
          r = c.useMemo(function () {
        return new L(e);
      }, [e]);
      return c.createElement(S, _w({
        cms: r
      }, e.sidebar), c.createElement(t, _w({}, n)));
    };
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});